import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getModelForResourceType} from 'resources/modelRegistry';

import {addToast, Button, Dialogue, Text} from '@albert-io/atomic';

const GenerateJoinCodeDialogue = ({classroom, customQuery, handleClose, onSuccess, ...rest}) => {
  const [isPending, setIsPending] = useState(false);

  const generateNewCode = async () => {
    try {
      setIsPending(true);
      const response = await classroom.resetInviteCode().save({customQuery});
      addToast({
        title: 'Success!',
        color: 'positive',
        message: 'New enrollment code generated successfully.'
      });
      onSuccess(response);
    } catch (error) {
      addToast({
        title: 'Something went wrong',
        color: 'negative',
        message: 'Failed to generate a new code. If the problem persists, contact us.'
      });
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Dialogue handleClose={handleClose} {...rest}>
      <Dialogue.Title align='center'>Generate a new code</Dialogue.Title>
      <Dialogue.Body align='center'>
        <Text as='p' bold>
          Previous enrollment codes will no longer be valid.
        </Text>
        <Text as='p'>Generate a new code for {classroom.getName()}?</Text>
      </Dialogue.Body>
      <Dialogue.BtnGroup direction='column' fillColumn>
        <Button
          disabled={isPending}
          onClick={generateNewCode}
          data-testid='generate-join-code-dialogue__generate-code-btn'
        >
          Generate a new code
        </Button>
        <Button color='secondary' onClick={handleClose}>
          Keep current code
        </Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

GenerateJoinCodeDialogue.propTypes = {
  classroom: PropTypes.instanceOf(getModelForResourceType('classroom_v1')),
  customQuery: PropTypes.object,
  handleClose: PropTypes.func,
  onSuccess: PropTypes.func
};

GenerateJoinCodeDialogue.defaultProps = {
  customQuery: {},
  onSuccess: () => {}
};

export default GenerateJoinCodeDialogue;
